import dayjs from "dayjs";
import utils from "utils";
import service from "utils/service"
import configureStore from "store";
import api, { niyama } from "utils/api";
import { message } from "antd";
import { CONSTANTS } from "utils/constant";
const { store } = configureStore();
class Service {

    #IsObject(obj) {
        return typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
    }

    DestructureObject(config) {
        let { finalOut = {}, data, excludeKeys = [] } = config;
        typeof data == "object" && data && Object.keys(data).forEach(m => {
            if (excludeKeys.indexOf(m) == -1) finalOut[m] = data[m];
            if (this.#IsObject(finalOut[m]) && excludeKeys.indexOf(m) == -1) this.DestructureObject({ finalOut, data: data[m], excludeKeys })
        })

        return finalOut;
    }

    UpdateObjectKeyValues(config) {
        let { previousState = {}, nextProps = {} } = config;
        let finalOut = previousState;
        typeof finalOut == "object" && finalOut && Object.keys(finalOut).forEach(key => {
            if (dayjs.isDayjs(previousState[key])) finalOut[key] = utils.FormatDate(nextProps[key], "UTC", "day");
            else if (this.#IsObject(finalOut[key])) this.UpdateObjectKeyValues({ previousState: finalOut[key], nextProps });
            else
                if (finalOut[key] != nextProps[key]) finalOut[key] = nextProps[key]
        })

        return finalOut
    }

    AssignDropDownValues(data = {}, fields = []) {
        const { phi_dropdown_values = [] } = JSON.parse(localStorage.getItem("phiReducer")) || window.store.getState()?.phiReducer || store?.getState()?.phiReducer  || {};
        this.#IsObject(data) && Object.keys(data).forEach(key => {
            if (this.#IsObject(data[key]) && !dayjs.isDayjs(data[key])) data[key] = this.AssignDropDownValues(data[key], fields)
            if (Array.isArray(data[key])) data[key].forEach(m => this.AssignDropDownValues(m, fields))
            if (fields.indexOf(key) > -1 && data[key]) {
                phi_dropdown_values.forEach(m => {
                    if (m['id'] == data[key][`${key}_id`]) data[key][`${key}_value`] = m[`field_value`]
                });
            }
        });
        return data;
    }

    AssignCheckBoxValues(data = {}, fields = [], state = {}) {
        this.#IsObject(data) && Object.keys(data).forEach(key => {
            if (this.#IsObject(data[key]) && !dayjs.isDayjs(data[key])) data[key] = this.AssignCheckBoxValues(data[key], fields, state)
            if (fields.indexOf(key) > -1 && state[key]) {
                let { options = [] } = state[key] || {};
                data[key] = options.map(m => ({
                    is_selected: (data[key] || []).indexOf(m) > -1 ? true : false,
                    selected_value: m
                }));
            }
        });
        return data;
    }

    GetAllDropDownValues() {
        const { phi_dropdown_values = [] } = JSON.parse(localStorage.getItem("phiReducer")) || window.store.getState()?.phiReducer || store?.getState()?.phiReducer || {};
        return phi_dropdown_values;
    }

    GetDropDownCheckboxValues(fields = [],manualDropdDownValues =[]) {
        let { phi_dropdown_values = [] } = JSON.parse(localStorage.getItem("phiReducer")) || window.store.getState()?.phiReducer || store?.getState()?.phiReducer || {};
        if(phi_dropdown_values.length == 0){
            phi_dropdown_values = manualDropdDownValues;
        }
        let finalOut = phi_dropdown_values.reduce((acc, m) => {
            if (fields.indexOf(m.field_name) > -1) {
                if (acc.hasOwnProperty(utils.ConvertToUnderscores(m.field_name)?.toLowerCase())) {
                    acc[utils.ConvertToUnderscores(m.field_name)?.toLowerCase()].push({
                        label: m.field_value,
                        value: parseInt(m.field_id),
                        field_type: m.field_type,
                        sort_id:m.sort_id

                    })
                } else {
                    acc[utils.ConvertToUnderscores(m.field_name)?.toLowerCase()] = [{
                        label: m.field_value,
                       // value: m.field_id,
                       value: parseInt(m.field_id),
                        field_type: m.field_type,
                        sort_id: m.sort_id
                    }]
                }
            }
          
            return acc;
        }, {});
       

        Object.keys(finalOut || {}).forEach(key => {
            if (Array.isArray(finalOut[key])) {
                finalOut[key] = utils.Sort(finalOut[key], "asc", "label")
            }
        });
        return finalOut;
    }

    GetCheckBoxValuesFromData(data = {}, fields = [], finalOut = {}) {
        (typeof data == "object" && Object.keys(data || {})).forEach(key => {
            if (this.#IsObject(data[key])) this.GetCheckBoxValuesFromData(data[key], fields, finalOut);
            if (fields.indexOf(key) > -1 && !finalOut[key]) {
                finalOut[key] = {};
                finalOut[key]["selected"] = (Array.isArray(data[key]) && data[key] || []).reduce((acc, m) => {
                    if (m.is_selected) acc.push(m.selected_value);
                    return acc;
                }, [])
                finalOut[key]["options"] = (Array.isArray(data[key]) && data[key] || []).reduce((acc, m) => {
                    acc.push(m.selected_value);
                    return acc;
                }, [])
            }
        });
        return finalOut;
    }

    ConvertDateTodayjs(data = {}, fields = []) {
        typeof data == "object" && Object.keys(data || {}).forEach(m => {
            if (this.#IsObject(data[m])) data[m] = this.ConvertDateTodayjs(data[m], fields);
            if (Array.isArray(data[m])) data[m].forEach(n => this.ConvertDateTodayjs(n), fields);
            if (fields.indexOf(m) > -1) {
                let dateObj = data[m] && dayjs(data[m]) || null;
                data[m] = dayjs.isDayjs(dateObj) && dateObj || null;
            }
        });

        return data;
    }

    ConvertdayjsToDate(data = {}, fields = [], format = "DATE_1") {
        typeof data == "object" && Object.keys(data || {}).forEach(m => {
            if (this.#IsObject(data[m])) data[m] = this.ConvertdayjsToDate(data[m], fields, format);
            if (Array.isArray(data[m])) data[m].forEach(n => this.ConvertDateTodayjs(n), fields, format);
            if (fields.indexOf(m) > -1) data[m] = utils.FormatDate(data[m], format, true);
        })

        return data;
    }

    ReplaceUndefinedToString(data = {}) {
        this.#IsObject(data) && Object.keys(data).forEach(key => {
            if (this.#IsObject(data[key]) && !dayjs.isDayjs(data[key])) this.ReplaceUndefinedToString(data[key]);
            if (Array.isArray(data[key])) data[key].forEach(m => this.ReplaceUndefinedToString(m));
            if (data[key] == undefined) data[key] = ''
            if (data[key] == "null") data[key] = null
        })

        return data
    }

    getKeyByValue(object, value) {
        let finalArray = [];
        Object.keys(object).forEach((key) => {
            value.map((ele) => {
                if (key == ele) {
                    finalArray.push(key + "-" + object[key])
                }
            })
        })
        return finalArray
    }

    getKeyById(object, value) {
        

        let finalArray = [];
        Object.keys(object).forEach((key) => {
            value.map((ele) => {
                if (key == ele) {
                    if (((object[key]).length > 1)) {
                        finalArray.push(key + "-" + object[key])
                    }
                }
            })
        })
        return finalArray
    }

    retreiveLabels = (inputArray, dropdownlist) => {
        let objreturn = new Object();
        inputArray.forEach((value) => {
            if (value !== undefined && value !== null) {
                const type = value.split('-')[0];
                let filterValue = value.split('-')[1];
                filterValue = parseInt(filterValue)
                const filterLabel = dropdownlist[type].filter((data) => data.value === filterValue).map((data) => data.label);
                objreturn[type] = filterLabel[0]
            }
        });
        return objreturn;
    };

    retreiveValue = (inputArray, dropdownlist) => {
        let objreturn = new Object();
        inputArray.forEach((value) => {
            if (value !== undefined && value !== null) {
                const type = value.split('-')[0];
                const filterValue = value.split('-')[1];
                const filterLabel = dropdownlist[type].filter((data) => data.label === filterValue).map((data) => data.value);
                objreturn[type] = filterLabel[0]
            }
        });
        return objreturn;
    };


    UpdateData(path, values = {},patient_id = "",type="") {
        let url = `${niyama}${path + "-api"}/`;
        let finalObj = this.ReplaceUndefinedToString(values);
        return (async () => await service.post(url, { data: finalObj, is_applicable: true, is_completed: true , is_short_phi_completed : true, patient_id : patient_id || localStorage.getItem("patient_id") || window.store.getState()?.patientDetailReducer?.patient_detail || store?.getState()?.patientDetailReducer?.patient_detail||'' })
            .then(async (res) => {
                if (res?.data?.status == 200) {
                    if (path == "socio-detail") {
                        let subscription = localStorage.getItem("subscription") === null ? {} : JSON.parse(localStorage.getItem("subscription"));
                        let output = { ...subscription, is_socio_demographic: true }
                        localStorage.setItem("subscription", JSON.stringify(output));
                    }
                    return await api.phi_summary(patient_id || localStorage.getItem("patient_id") || window.store.getState()?.patientDetailReducer?.patient_detail || store?.getState()?.patientDetailReducer?.patient_detail || '',
                    "doctor",
                    type || localStorage.getItem("patient_user_type") || window.store.getState()?.patientDetailReducer?.usertype|| window.store.getState()?.loginReducer?.user_details?.user_type  || store?.getState()?.patientDetailReducer?.usertype|| store?.getState()?.loginReducer?.user_details?.user_type,
                    localStorage.getItem("patient_gender") || window.store.getState()?.patientDetailReducer?.gender|| window.store.getState()?.loginReducer?.user_details?.gender || store?.getState()?.patientDetailReducer?.gender|| store?.getState()?.loginReducer?.user_details?.gender)
                        .then(response => {
                            let { data, status, message: msg } = response.data || {};
                            if (status == 200) {
                                // utils.Modal(false, { from: path, data: data });
                                message.success(`${CONSTANTS.DETAILS_SAVE_SUCCESSFULLY}`, ErrorDuration);
                                // utils.Toast({ type: "success", message: "Patient summary details updated successfully!!" })
                            } else {
                                message.error(msg, ErrorDuration);
                                // utils.Toast({ type: "error", message: message })
                            }
                            return data;
                        });
                } else {
                    message.error(res?.data?.message, ErrorDuration);
                }
            }))();
    }


    AssignDropDownDefaultValues(data = {}, fields = []) {
        this.#IsObject(data) && Object.keys(data).forEach(key => {
            if (this.#IsObject(data[key]) && !dayjs.isDayjs(data[key])) this.AssignDropDownDefaultValues(data[key], fields);
            else if (Array.isArray(data[key])) data[key].forEach(m => this.AssignDropDownDefaultValues(m, fields));
            else if (data[key] === 0) data[key] = null
        })

        return data;
    }

    RenderFormLabel(label) {
        return <span>{label || ''}<span style={{ color: "red", fontSize: "14px" }}>&nbsp;*</span></span>
    }
}

export default new Service()